import { render, staticRenderFns } from "./PatrimonioDetalhe.vue?vue&type=template&id=cc2422ee&"
import script from "./PatrimonioDetalhe.vue?vue&type=script&lang=js&"
export * from "./PatrimonioDetalhe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports